/**
 * DayTrip:
 * * DaySummary
 * * PoiList
 *   * Poi
 *   * Route
 *   * PoiAdd
 * * EditButton
 */

import React from 'react';
import propTypes from 'prop-types';
import DaySummary from './DaySummary';
import PoiList from './PoiList';
// import EditButton from '../EditButton';


import './style.css';


DayTrip.propTypes = {
  trip: propTypes.object.isRequired,
  route: propTypes.object,
  day: propTypes.number.isRequired
};

export default function DayTrip(props) {
  return (
    <div className='day-trip'>
      <DaySummary {...props} />
      <PoiList {...props} />
      {/* <EditButton {...props} /> */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/index.js